import fetch from 'isomorphic-fetch';
import {commonHeaders, commonErrorHandler} from './fetch.util';

export const PC_BANG_NOTICES_REQUEST = 'PC_BANG_NOTICES_REQUEST';
export const PC_BANG_NOTICES_RESPONSE = 'PC_BANG_NOTICES_RESPONSE';
export const PC_BANG_NOTICE_BY_ID_REQUEST = 'PC_BANG_NOTICE_BY_ID_REQUEST';
export const PC_BANG_NOTICE_BY_ID_RESPONSE = 'PC_BANG_NOTICE_BY_ID_RESPONSE';

export function pcBangNoticesRequest() {
  return {
    type: PC_BANG_NOTICES_REQUEST,
  };
}

export function pcBangNoticesResponse(notices, page, totalCount) {
  return {
    type: PC_BANG_NOTICES_RESPONSE,
    notices,
    page,
    totalCount,
  };
}

export function pcBangNoticeByIdRequest() {
  return {
    type: PC_BANG_NOTICE_BY_ID_REQUEST,
  };
}

export function pcBangNoticeByIdResponse(notice) {
  return {
    type: PC_BANG_NOTICE_BY_ID_RESPONSE,
    notice,
  };
}

export function fetchPcBangNotices(page, pageSize) {
  return dispatch => {
    dispatch(pcBangNoticesRequest());

    fetch(`${API_URL}/notices?page=${page - 1}&pageSize=${pageSize}`, {
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return [];
      })
      .catch(() => [])
      .then(notices => dispatch(pcBangNoticesResponse(notices.content, page, notices.totalElements)));
  };
}

export function fetchPcBangNoticeById(noticeId) {
  return dispatch => {
    dispatch(pcBangNoticeByIdRequest());

    fetch(`${API_URL}/notices/by-notice-id/${noticeId}`, {
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return {};
      })
      .catch(() => {})
      .then(notice => dispatch(pcBangNoticeByIdResponse(notice)));
  };
}
